/**

 * Canonical permission codes — keep in sync with SQL seed (Scripts/Add_Rbac_Tables_AndSeed.sql)

 * and JWT "perm" claims issued at login.

 */

export const P = {
  PAGE_DASHBOARD: 'PAGE_DASHBOARD',

  PAGE_BOOKINGS: 'PAGE_BOOKINGS',

  PAGE_CREATE_ORDER: 'PAGE_CREATE_ORDER',

  PAGE_ORDERS: 'PAGE_ORDERS',

  PAGE_TABLE_ORDERS: 'PAGE_TABLE_ORDERS',

  PAGE_PAYMENTS: 'PAGE_PAYMENTS',
  // Accounts → Payments (Payment Ledger) actions, per tab. Seeded by
  // Scripts/Rbac_PageWise_Phase2.sql.
  ACC_PAY_HOTEL_ADD: 'ACC_PAY_HOTEL_ADD',
  ACC_PAY_HOTEL_EDIT: 'ACC_PAY_HOTEL_EDIT',
  ACC_PAY_REST_ADD: 'ACC_PAY_REST_ADD',
  ACC_PAY_REST_EDIT: 'ACC_PAY_REST_EDIT',
  ACC_PAY_EXPORT: 'ACC_PAY_EXPORT',
  ACC_PAY_PRINT: 'ACC_PAY_PRINT',
  // Accounts → Petty Cash actions, per pool (Hotel tab / Restaurant tab).
  PC_HOTEL_CASH_IN: 'PC_HOTEL_CASH_IN',
  PC_HOTEL_CASH_OUT: 'PC_HOTEL_CASH_OUT',
  PC_REST_CASH_IN: 'PC_REST_CASH_IN',
  PC_REST_CASH_OUT: 'PC_REST_CASH_OUT',
  PC_EXPORT: 'PC_EXPORT',
  // Accounts → Customer Wallet actions.
  CW_COLLECT: 'CW_COLLECT',
  CW_EXPORT: 'CW_EXPORT',
  CW_PRINT: 'CW_PRINT',

  PAGE_INVOICE: 'PAGE_INVOICE',

  PAGE_REPORTS: 'PAGE_REPORTS',

  PAGE_SETTINGS: 'PAGE_SETTINGS',

  PAGE_USER_MANAGEMENT: 'PAGE_USER_MANAGEMENT',

  DASHBOARD_VIEW_REVENUE: 'DASHBOARD_VIEW_REVENUE',

  DASHBOARD_VIEW_TOTAL_SALES: 'DASHBOARD_VIEW_TOTAL_SALES',

  DASHBOARD_VIEW_OCCUPANCY: 'DASHBOARD_VIEW_OCCUPANCY',

  DASHBOARD_VIEW_CHECKINS: 'DASHBOARD_VIEW_CHECKINS',

  DASHBOARD_VIEW_CHECKOUTS: 'DASHBOARD_VIEW_CHECKOUTS',

  DASHBOARD_VIEW_RESTAURANT_REVENUE: 'DASHBOARD_VIEW_RESTAURANT_REVENUE',

  DASHBOARD_VIEW_ADDON_REVENUE: 'DASHBOARD_VIEW_ADDON_REVENUE',

  DASHBOARD_VIEW_ANALYTICS_CHARTS: 'DASHBOARD_VIEW_ANALYTICS_CHARTS',

  DASHBOARD_VIEW_AVAILABLE_ROOMS: 'DASHBOARD_VIEW_AVAILABLE_ROOMS',

  DASHBOARD_VIEW_PENDING_INVOICES: 'DASHBOARD_VIEW_PENDING_INVOICES',

  DASHBOARD_VIEW_MONTHLY_REVENUE: 'DASHBOARD_VIEW_MONTHLY_REVENUE',

  DASHBOARD_VIEW_TODAY_REVENUE: 'DASHBOARD_VIEW_TODAY_REVENUE',

  DASHBOARD_VIEW_NET_CASH: 'DASHBOARD_VIEW_NET_CASH',

  BOOKING_VIEW: 'BOOKING_VIEW',

  BOOKING_CREATE: 'BOOKING_CREATE',

  BOOKING_EDIT: 'BOOKING_EDIT',

  BOOKING_DELETE: 'BOOKING_DELETE',

  BOOKING_MANAGE: 'BOOKING_MANAGE',

  BOOKING_ADD_PAYMENT: 'BOOKING_ADD_PAYMENT',

  BOOKING_VIEW_PAYMENT: 'BOOKING_VIEW_PAYMENT',

  BOOKING_VIEW_DETAILS: 'BOOKING_VIEW_DETAILS',

  BOOKING_ADD_COVER_CHARGE: 'BOOKING_ADD_COVER_CHARGE',

  BOOKING_DISCOUNT: 'BOOKING_DISCOUNT',

  BOOKING_ADD_DISCOUNT: 'BOOKING_ADD_DISCOUNT',

  BOOKING_MANAGE_ADDONS: 'BOOKING_MANAGE_ADDONS',

  BOOKING_GENERATE_INVOICE: 'BOOKING_GENERATE_INVOICE',

  BOOKING_PREVIEW_INVOICE: 'BOOKING_PREVIEW_INVOICE',

  BOOKING_CHECKIN: 'BOOKING_CHECKIN',

  BOOKING_CHECKOUT: 'BOOKING_CHECKOUT',

  BOOKING_CANCEL: 'BOOKING_CANCEL',

  // Guest identity / de-duplication
  GUEST_MERGE: 'GUEST_MERGE',

  // Inventory — override to issue/consume expired stock, mark disposal, etc.
  INVENTORY_MANAGER: 'INVENTORY_MANAGER',

  ORDER_VIEW: 'ORDER_VIEW',

  ORDER_CREATE: 'ORDER_CREATE',

  ORDER_EDIT: 'ORDER_EDIT',

  ORDER_CANCEL: 'ORDER_CANCEL',

  ORDER_DISCOUNT: 'ORDER_DISCOUNT',

  ORDER_ADD_DISCOUNT: 'ORDER_DISCOUNT',

  TABLE_ORDER_VIEW: 'TABLE_ORDER_VIEW',

  TABLE_ORDER_CREATE: 'TABLE_ORDER_CREATE',

  TABLE_ORDER_DISCOUNT: 'TABLE_ORDER_DISCOUNT',

  TABLE_ORDER_ADD_DISCOUNT: 'TABLE_ORDER_DISCOUNT',

  TABLE_ORDER_MERGE_TABLE: 'TABLE_ORDER_MERGE_TABLE',

  TABLE_ORDER_MERGE_TABLES: 'TABLE_ORDER_MERGE_TABLE',

  TABLE_ORDER_SPLIT_BILL: 'TABLE_ORDER_SPLIT_BILL',

  ORDER_ADD_PAYMENT: 'ORDER_ADD_PAYMENT',

  ORDER_PRINT_BILL: 'ORDER_PRINT_BILL',

  TABLE_ORDER_PRINT_BILL: 'TABLE_ORDER_PRINT_BILL',

  TABLE_ORDER_MARK_PAID: 'TABLE_ORDER_MARK_PAID',

  TABLE_ORDER_GENERATE_KOT: 'TABLE_ORDER_GENERATE_KOT',

  // Voiding a bill the guest has ALREADY paid. Deliberately separate from the
  // ordinary cancel: that one only ever touches an unsettled order, while this
  // one deletes a payment record and changes a figure the day has already
  // counted. The server enforces it too - see RestaurantOrderController.Cancel.
  TABLE_ORDER_CANCEL_SETTLED: 'TABLE_ORDER_CANCEL_SETTLED',

  USER_MANAGE_RBAC: 'USER_MANAGE_RBAC',

  // ---- Spa POS ----
  PAGE_SPA: 'PAGE_SPA',
  SPA_SERVICE_MANAGE: 'SPA_SERVICE_MANAGE',
  SPA_THERAPIST_MANAGE: 'SPA_THERAPIST_MANAGE',
  SPA_BOOKING_VIEW: 'SPA_BOOKING_VIEW',
  SPA_BOOKING_CREATE: 'SPA_BOOKING_CREATE',
  SPA_BOOKING_CANCEL: 'SPA_BOOKING_CANCEL',
  SPA_PAYMENT_ADD: 'SPA_PAYMENT_ADD',
  SPA_INVOICE_GENERATE: 'SPA_INVOICE_GENERATE',
  SPA_REFUND: 'SPA_REFUND',

  // ---- Laundry POS ----
  PAGE_LAUNDRY: 'PAGE_LAUNDRY',
  LAUNDRY_ITEM_MANAGE: 'LAUNDRY_ITEM_MANAGE',
  LAUNDRY_ORDER_VIEW: 'LAUNDRY_ORDER_VIEW',
  LAUNDRY_ORDER_CREATE: 'LAUNDRY_ORDER_CREATE',
  LAUNDRY_ORDER_STATUS_CHANGE: 'LAUNDRY_ORDER_STATUS_CHANGE',
  LAUNDRY_ORDER_CANCEL: 'LAUNDRY_ORDER_CANCEL',

  // ---- Mini-Bar POS ----
  PAGE_MINIBAR: 'PAGE_MINIBAR',
  MINIBAR_ITEM_MANAGE: 'MINIBAR_ITEM_MANAGE',
  MINIBAR_ASSIGNMENT_MANAGE: 'MINIBAR_ASSIGNMENT_MANAGE',
  MINIBAR_CONSUMPTION_RECORD: 'MINIBAR_CONSUMPTION_RECORD',
  MINIBAR_CONSUMPTION_ADJUST: 'MINIBAR_CONSUMPTION_ADJUST',
  MINIBAR_REPLENISH: 'MINIBAR_REPLENISH',

  // ---- Housekeeping ----
  PAGE_HOUSEKEEPING: 'PAGE_HOUSEKEEPING',
  HK_STAFF_MANAGE: 'HK_STAFF_MANAGE',
  HK_TASK_VIEW: 'HK_TASK_VIEW',
  HK_TASK_CREATE: 'HK_TASK_CREATE',
  HK_TASK_STATUS_CHANGE: 'HK_TASK_STATUS_CHANGE',
  HK_TASK_VERIFY: 'HK_TASK_VERIFY',
  HK_ROOM_STATUS_UPDATE: 'HK_ROOM_STATUS_UPDATE',
  HK_MAINTENANCE_RAISE: 'HK_MAINTENANCE_RAISE',
  HK_MAINTENANCE_RESOLVE: 'HK_MAINTENANCE_RESOLVE',

  // ---- Restaurant, page-wise (Scripts/Rbac_PageWise_Restaurant.sql) ----
  // Which order screens may be opened.
  POS_DINEIN_OPEN: 'POS_DINEIN_OPEN',
  POS_TAKEAWAY_OPEN: 'POS_TAKEAWAY_OPEN',
  POS_PICKUP_OPEN: 'POS_PICKUP_OPEN',
  POS_DELIVERY_OPEN: 'POS_DELIVERY_OPEN',
  // Swiggy / Zomato orders tab (Scripts/Rbac_OnlineOrders.sql). OPT-IN: off
  // for everyone until turned On for a user - see OPT_IN_CODES in
  // PermissionProvider.
  POS_ONLINE_ORDERS_OPEN: 'POS_ONLINE_ORDERS_OPEN',
  // What may be done on the order screen (all order types).
  POS_PLACE_ORDER: 'POS_PLACE_ORDER',
  POS_INVOICE_ONLY: 'POS_INVOICE_ONLY',
  POS_ROOM_ORDER: 'POS_ROOM_ORDER',
  POS_MARK_PAID: 'POS_MARK_PAID',
  POS_DISCOUNT: 'POS_DISCOUNT',
  // Take service charge OFF a bill at settle (Scripts/Add_Order_ServiceCharge.sql).
  // Granted to NO role by the script - only the people the owner chooses.
  // Without it the service charge line still shows; the remove button does not.
  POS_SC_REMOVE: 'POS_SC_REMOVE',
  // Override item price / amount - one switch per order type (POS_PRICE_EDIT
  // is the Dine In one; the code stays so existing grants keep working).
  POS_PRICE_EDIT: 'POS_PRICE_EDIT',
  TA_PRICE_OVERRIDE: 'TA_PRICE_OVERRIDE',
  PU_PRICE_OVERRIDE: 'PU_PRICE_OVERRIDE',
  DL_PRICE_OVERRIDE: 'DL_PRICE_OVERRIDE',
  ROOM_PRICE_OVERRIDE: 'ROOM_PRICE_OVERRIDE',
  POS_EDIT_ITEM: 'POS_EDIT_ITEM',
  POS_CANCEL_ITEM: 'POS_CANCEL_ITEM',
  POS_TENDER_CASH: 'POS_TENDER_CASH',
  POS_TENDER_CARD: 'POS_TENDER_CARD',
  POS_TENDER_UPI: 'POS_TENDER_UPI',
  POS_TENDER_SPLIT: 'POS_TENDER_SPLIT',
  POS_TENDER_ONLINE: 'POS_TENDER_ONLINE',
  POS_TENDER_DUE: 'POS_TENDER_DUE',
  POS_MENU_SETUP: 'POS_MENU_SETUP',
  // Quick Bill
  QB_OPEN: 'QB_OPEN',
  QB_PROCEED_PAYMENT: 'QB_PROCEED_PAYMENT',
  QB_PAID_PRINT: 'QB_PAID_PRINT',
  QB_PRICE_OVERRIDE: 'QB_PRICE_OVERRIDE',
  // Table Reservation
  RES_OPEN: 'RES_OPEN',
  RES_CREATE: 'RES_CREATE',
  // QR Orders
  QR_OPEN: 'QR_OPEN',
  QR_APPROVE: 'QR_APPROVE',
  QR_REJECT: 'QR_REJECT',
  // Restaurant Payments
  RP_OPEN: 'RP_OPEN',
  RP_EDIT_PAYMENT: 'RP_EDIT_PAYMENT',
  RP_EDIT_AMOUNT: 'RP_EDIT_AMOUNT',
  RP_EXPORT: 'RP_EXPORT',
  // Order History
  OH_OPEN: 'OH_OPEN',
  OH_VIEW_ORDER: 'OH_VIEW_ORDER',
  OH_OPEN_INVOICE: 'OH_OPEN_INVOICE',

  // ---- Reception, page-wise (Scripts/Rbac_PageWise_Phase2.sql) ----
  // Front desk (Today / Arrivals / Departures / Rooms)
  FD_CHECKIN: 'FD_CHECKIN',
  FD_CHECKOUT: 'FD_CHECKOUT',
  FD_ROOM_STATUS: 'FD_ROOM_STATUS',
  // Quick Booking
  QBK_CREATE: 'QBK_CREATE',
  // Room Reservation
  RR_CREATE: 'RR_CREATE',
  RR_CANCEL: 'RR_CANCEL',
  // Hourly Booking
  HB_CREATE: 'HB_CREATE',
  HB_PRICES: 'HB_PRICES',
  // Change Room
  CR_CHANGE: 'CR_CHANGE',
  CR_REMOVE_ROOM: 'CR_REMOVE_ROOM',
  // Block Room
  BR_HOLD: 'BR_HOLD',
  BR_MAINTENANCE: 'BR_MAINTENANCE',
  // Group Booking
  GB_CHECKIN: 'GB_CHECKIN',
  GB_INVOICE: 'GB_INVOICE',
  GB_ADD_PAYMENT: 'GB_ADD_PAYMENT',
  // Channel Manager
  CM_CONFIG: 'CM_CONFIG',
  CM_FETCH: 'CM_FETCH',
  CM_IMPORT: 'CM_IMPORT',
  CM_PUSH: 'CM_PUSH',
  // Reset Data
  RD_RUN: 'RD_RUN',
};

// Sidebar page → the switch that OPENS it (Users → User Permissions → the
// department → "Open …"). Applied in AdminLayout on top of the old menuKey
// grant: a page shows only when both allow it. A path not listed here has no
// open-switch and is never hidden by this map; a user with no permission
// codes at all passes every switch (fail-open), so a company that never set
// up roles is untouched. Restaurant Orders tabs carry their own codes in
// RestaurantOrdersLayout. Every code here MUST exist in the database
// (Scripts/Rbac_PageWise_Phase2.sql) and be granted to existing roles, or a
// role-holding user would lose the page the day the app is published.
export const PAGE_RBAC = {
  // Swiggy / Zomato orders - an OPT-IN switch, so typing the address does not
  // open it for somebody who was not given it. (The one code here that is
  // deliberately NOT granted to roles.)
  '/admin/OnlineOrders': 'POS_ONLINE_ORDERS_OPEN',
  // Reception
  '/admin/ReceptionToday': 'PG_RECEPTION_TODAY',
  '/admin/Arrivals': 'PG_ARRIVALS',
  '/admin/Departures': 'PG_DEPARTURES',
  '/admin/RoomGrid': 'PG_ROOM_GRID',
  '/admin/manageinventory': 'PG_NEW_BOOKING',
  '/admin/QuickBooking': 'PG_QUICK_BOOKING',
  '/admin/RoomReservation': 'PG_ROOM_RESERVATION',
  '/admin/OtaBookings': 'PG_OTA_BOOKINGS',
  '/admin/GuestProfile': 'PG_GUESTS',
  '/admin/HourlyBooking': 'PG_HOURLY_BOOKING',
  '/admin/BookingReport': P.PAGE_BOOKINGS,
  '/admin/Calender': 'PG_CALENDAR',
  '/admin/Changeroom': 'PG_CHANGE_ROOM',
  '/admin/HoldRoom': 'PG_BLOCK_ROOM',
  '/admin/BulkBookings': 'PG_GROUP_BOOKING',
  '/admin/ChannelManager': 'PG_CHANNEL_MANAGER',
  '/admin/ResetData': 'PG_RESET_DATA',
  // Restaurant (sidebar entries outside the Orders tabs)
  '/admin/KitchenPendingOrders': 'PG_KITCHEN',
  '/admin/KotReport': 'PG_KOT_REPORT',
  // Pub / Club
  '/admin/PubCardRequests': 'PG_PUB_CARD_REQUESTS',
  // Services (existing page codes)
  '/admin/Spa/Bookings': P.PAGE_SPA,
  '/admin/Spa/Services': P.PAGE_SPA,
  '/admin/Spa/Therapists': P.PAGE_SPA,
  '/admin/Laundry/Orders': P.PAGE_LAUNDRY,
  '/admin/Laundry/Items': P.PAGE_LAUNDRY,
  '/admin/MiniBar/Consumption': P.PAGE_MINIBAR,
  '/admin/MiniBar/Items': P.PAGE_MINIBAR,
  '/admin/Housekeeping/Dashboard': P.PAGE_HOUSEKEEPING,
  '/admin/Housekeeping/Tasks': P.PAGE_HOUSEKEEPING,
  '/admin/Housekeeping/Staff': P.PAGE_HOUSEKEEPING,
  // Store
  '/admin/StoreLocations': 'PG_STORE_LOCATIONS',
  '/admin/StockDashboard': 'PG_STOCK',
  '/admin/StockTransfer': 'PG_STOCK_TRANSFER',
  '/admin/StockTransactionHistory': 'PG_STOCK_HISTORY',
  '/admin/StockOpeningClosingReport': 'PG_STOCK_OPENING_CLOSING',
  '/admin/IndentEntry': 'PG_INDENT_ENTRY',
  '/admin/IndentList': 'PG_INDENT_LIST',
  '/admin/PurchaseEntry': 'PG_PURCHASE',
  '/admin/SupplierMaster': 'PG_SUPPLIERS',
  '/admin/RecipeMaster': 'PG_RECIPES',
  // Accounts
  '/admin/Paymentreport': P.PAGE_PAYMENTS,
  '/admin/pettycashmanagement': 'PG_PETTY_CASH',
  '/admin/Customerwallet': 'PG_CUSTOMER_WALLET',
  '/admin/AmountCorrection': 'PG_CORRECTIONS',
  // Staff (HR)
  '/admin/Hr/Dashboard': 'PG_HR_DASHBOARD',
  '/admin/Hr/Reports': 'PG_HR_REPORTS',
  '/admin/Hr/Departments': 'PG_HR_DEPARTMENTS',
  '/admin/Hr/Designations': 'PG_HR_DESIGNATIONS',
  '/admin/Hr/Employees': 'PG_HR_EMPLOYEES',
  '/admin/Hr/Shifts': 'PG_HR_SHIFTS',
  '/admin/Hr/Attendance': 'PG_HR_ATTENDANCE',
  '/admin/Hr/LeaveTypes': 'PG_HR_LEAVE_TYPES',
  '/admin/Hr/LeaveRequests': 'PG_HR_LEAVE_REQUESTS',
  '/admin/Hr/Overtime': 'PG_HR_OVERTIME',
  '/admin/Hr/AdvanceSalary': 'PG_HR_ADVANCE_SALARY',
  '/admin/Hr/Loans': 'PG_HR_LOANS',
  '/admin/Hr/SalaryStructure': 'PG_HR_SALARY_STRUCTURE',
  '/admin/Hr/Payroll': 'PG_HR_PAYROLL',
  '/admin/Hr/SalaryPayments': 'PG_HR_SALARY_PAYMENTS',
  '/admin/Hr/ServiceCharge': 'PG_HR_SERVICE_CHARGE',
  '/admin/Hr/Tips': 'PG_HR_TIPS',
  '/admin/Hr/StaffMeals': 'PG_HR_STAFF_MEALS',
  '/admin/Hr/UniformDeposit': 'PG_HR_UNIFORM_DEPOSIT',
  // Reports
  '/admin/Bookingfilter': 'PG_RPT_BOOKING',
  '/admin/Guestreport': 'PG_RPT_GUEST',
  '/admin/NightAuditReport': 'PG_RPT_NIGHT_AUDIT',
  '/admin/Holdreport': 'PG_RPT_HOLD',
  '/admin/packagereport': 'PG_RPT_PACKAGE',
  '/admin/AddonProfitReport': 'PG_RPT_ADDON',
  '/admin/rooms': 'PG_RPT_ROOM_LIST',
  '/admin/InvoiceReport': 'PG_RPT_INVOICE',
  '/admin/ItemReport': 'PG_RPT_ITEM',
  '/admin/RestaurantInvoiceReport': 'PG_RPT_RESTRO',
  '/admin/BookingHistory': 'PG_RPT_BOOKING_HISTORY',
  '/admin/AllCategory': 'PG_RPT_CATEGORY',
  '/admin/PurchaseReports': 'PG_RPT_PURCHASE',
  '/admin/PurchaseLedgerReport': 'PG_RPT_PURCHASE_LEDGER',
  '/admin/AgentReport': 'PG_RPT_AGENT',
  '/admin/Agentcommissionreport': 'PG_RPT_AGENT_COMMISSION',
  '/admin/ActivityLog': 'PG_RPT_ACTIVITY_LOG',
  '/admin/GstReports': 'PG_RPT_GST',
  // Setup
  '/admin/hotels': 'PG_MY_HOTEL',
  '/admin/rooms/add': 'PG_ROOMS_SETUP',
  '/admin/roomtype': 'PG_ROOM_TYPES',
  '/admin/managepackage': 'PG_PACKAGES',
  '/admin/Addonm': 'PG_EXTRAS',
  '/admin/AddItem': 'PG_RESTAURANT_SETUP',
  '/admin/QrCodeGenerator': 'PG_QR_CODES',
  '/admin/Agent': 'PG_AGENTS',
  '/admin/Couponmaster': 'PG_COUPONS',
  '/admin/CompanySettings': 'PG_COMPANY_SETTINGS',
  '/admin/BusinessSettings': 'PG_BUSINESS_SETTINGS',
  '/admin/WebsiteBuilder': 'PG_WEBSITE_BUILDER',
  '/admin/WebsiteMenu': 'PG_WEBSITE_MENU',
  // Users
  '/admin/CreateUser': P.PAGE_USER_MANAGEMENT,
  '/admin/UserPermission': P.PAGE_USER_MANAGEMENT,
  '/admin/RbacRoles': 'PG_ROLES',
  '/admin/RbacUserOverrides': 'PG_SPECIAL_ACCESS',
  '/admin/UserReport': 'PG_USER_REPORT',
};

// The payment tender a cashier picks on the order screen → the switch that
// allows it. Ids as CreateOrder's PAYMENT_MODES spells them.
export const TENDER_RBAC = {
  Cash: P.POS_TENDER_CASH,
  Card: P.POS_TENDER_CARD,
  UPI: P.POS_TENDER_UPI,
  Split: P.POS_TENDER_SPLIT,
  Online: P.POS_TENDER_ONLINE,
  Due: P.POS_TENDER_DUE,
};

/** Sidebar menuKey → RBAC page code (when granular RBAC is active). */

export const MENU_RBAC = {
  dashboard: P.PAGE_DASHBOARD,

  BookingReport: P.PAGE_BOOKINGS,

  manageinventory: P.PAGE_BOOKINGS,

  HoldRoom: P.PAGE_BOOKINGS,

  Changeroom: P.PAGE_BOOKINGS,

  Calender: P.PAGE_BOOKINGS,

  Paymentreport: P.PAGE_REPORTS,

  Bookingfilter: P.PAGE_REPORTS,

  InvoiceReport: P.PAGE_REPORTS,

  Guestreport: P.PAGE_REPORTS,

  Holdreport: P.PAGE_REPORTS,

  CreateOrder: P.PAGE_CREATE_ORDER,

  Order: P.PAGE_ORDERS,

  RestaurantOrder: P.PAGE_TABLE_ORDERS,

  CreateUser: P.PAGE_USER_MANAGEMENT,

  UserPermission: P.PAGE_USER_MANAGEMENT,

  PettyCashManagement: P.PAGE_PAYMENTS,

  // Spa POS
  'Spa/Services': P.PAGE_SPA,
  'Spa/Therapists': P.PAGE_SPA,
  'Spa/Bookings': P.PAGE_SPA,

  // Laundry POS
  'Laundry/Items': P.PAGE_LAUNDRY,
  'Laundry/Orders': P.PAGE_LAUNDRY,

  // Mini-Bar POS
  'MiniBar/Items': P.PAGE_MINIBAR,
  'MiniBar/Consumption': P.PAGE_MINIBAR,

  // Housekeeping
  'Housekeeping/Dashboard': P.PAGE_HOUSEKEEPING,
  'Housekeeping/Tasks': P.PAGE_HOUSEKEEPING,
  'Housekeeping/Staff': P.PAGE_HOUSEKEEPING,
};
